module.exports = __webpack_public_path__ + "img/circle.c9bde09c.png";